import React, { useEffect, useState } from "react";
import Drawer from "../../components/Drawer/Drawer";
import CustomAccordion from "../../components/Accordion/Accordion";
import OrganizationDescription from "../../components/SummaryReportCoC/OrganizationDescription/OrganizationDescription";
import ConfirmationOfChanges from "../../components/SummaryReportCoC/ConfirmationOfChanges/ConfirmationOfChanges";
import CertificateScope from "../../components/SummaryReportCoC/CertificateScope/CertificateScope";
import FscProductGroupList from "../../components/SummaryReportCoC/FscProductGroupList/FscProductGroupList";
import PeFcsfiRwProductCategories from "../../components/SummaryReportCoC/PeFcsfiRwProductCategories/PeFcsfiRwProductCategories";
import DocumentUpload from "../../components/SummaryReportCoC/DocumentUpload/DocumentUpload";
import ReclaimedMaterialsInfo from "../../components/SummaryReportCoC/ReclaimedMaterialsInfo/ReclaimedMaterialsInfo";
import MultiSiteGroupInfo  from "../../components/SummaryReportCoC/MultiSiteGroupInfo/MultiSiteGroupInfo";
import FscAafData  from "../../components/SummaryReportCoC/FscAafData/FscAafData"
import SummaryOfAssessment  from "../../components/SummaryReportCoC/SummaryOfAssessment/SummaryOfAssessment"
import Messages from "../../components/CocSummaryReportSection/Messages";
import FloatButton from "../../components/FloatButton";
import Toaster from "../../components/Toaster/Toster";
import { editSummaryReport } from "../../services/report.api";
import "./SummaryReport.css";
import { content } from "html2canvas/dist/types/css/property-descriptors/content";
import Loader from "../../components/Loader/loader.components";

interface SummaryReportProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reportId: any;
  projectId: any;
  folderPath: any;
  reportformData: any;
  section34Data: any;
  reportName: any;
}

const SummaryReport: React.FC<SummaryReportProps> = ({
  isDrawerOpen,
  setIsDrawerOpen,
  reportId,
  projectId,
  folderPath,
  reportformData,
  section34Data,
  reportName,
}) => {
  const [formData, setFormData] = useState({ ...reportformData });
  const [openAccordion, setOpenAccordion] = useState(new Set([1,2,3,4,5,6,7,8,9,10,11]));
  const [showToaster, setShowToaster] = useState(false);
  const [draftStatus, setDraftStatus] = useState("notStarted");
  const [isLoading, setIsLoading] = useState(false);
  const [initialFormData, setinitialFormData] = useState(formData);

  const addInvisibleChars = (str: string): string => {
    // Surround with zero-width space
    return `\u200B\u200B${str}\u200B`;
  };
  const cleanString = (str: string | null | undefined): string =>
    (str ?? "").replace(/[\u200B-\u200D\uFEFF]/g, "");

  const formatSpiceIds = (crtData: any) => {
    const processedSpices: any = [];

    const formFscOutComes = (fscO: any) => {
      const fscOutComes: any = [];
      fscO.forEach((element: any) => {
        fscOutComes.push(element.id)
      });
      return fscOutComes;
    }

    const findOpperCertificateId = (crtNumer: string) => {
      let opperCertId: string = "";
      if (section34Data.opportunityCertificates) {
        section34Data.opportunityCertificates.forEach((item: any) => {
          if (item.Certificate_Number__c === crtNumer) {
            opperCertId = item.id;
          }
        })
      };

      return opperCertId;
    }

    const formCertifiedSpececies = (specieData: any, productId: string) => {
      const processedSpecies: any = [];

      specieData.forEach((element: any) => {
        processedSpecies.push( {
          speciesId: element.id,
          certifiedProductId: productId,
          certifiedSpeciesId: element.certifiedSpeciesId,
        })
      });

      return processedSpecies;
    }

    if (crtData) {
      crtData.forEach((item: any) => {
      processedSpices.push({
      opportunityCertificateId: findOpperCertificateId(item.certificateId),
      certifiedProductId: item.certifiedProductId,
      level1: item.productCodeL1,
      level2: item.productCodeL2,
      level3: item.productCodeL3,
      tradeName: item.speciesCommonName,
      primaryActivity: item.primaryActivity,
      secondaryActivity: item.secondaryActivity,
      fscOutputClaim: formFscOutComes(item.fscOutputClaim) || [],
      certifiedSpecies: formCertifiedSpececies(item.speciesLatinName, item.certifiedProductId) || []
      
        })
      })
    }
    return processedSpices;
  } 

  const sortOpperCertificateIds = () => {
    const opperCertificates: any = [];
    if (section34Data?.opportunityCertificates) {
      section34Data.opportunityCertificates.forEach((item: any) => {
        opperCertificates.push({id: item.id, scopeOfCertification: item.Scope_of_certification__c})
      })
    }
    return opperCertificates;
  }
  
  const mapApiDataToFormData = (apiData: any) => {

    console.log(apiData)
    return {
      name: apiData.Name || "",
      contactFirstName: apiData.Contact_First_Name__c || "",
      contactSurname: apiData.Contact_Surname__c || "",
      streetAddress: apiData.Street_Address__c || "",
      email: apiData.Email__c || "",
      phoneCell: apiData.Phone_Cell__c || "",
      status: apiData.Status__c || null,
      project: apiData.Project__c || "",
      website: apiData.Website__c || "",
      generalDescription: apiData.General_Description__c || "",
      auditType: apiData.Audit_Type__c || "",
      auditorName: apiData.Auditor_Name__c || "",
      descriptionOfChanges: apiData.Description_Of_Changes__c || "",
      fscstdMultipleSitesGroup: !!apiData.FSC_STD_Multiple_Sites_Group__c,
      fscstdProjectCertification: !!apiData.FSC_STD_Project_Certification__c,
      fscstdReclaimedMaterial: !!apiData.FSC_STD_Reclaimed_Material__c,
      fscstdControlledWoodSourcing: !!apiData.FSC_STD_Controlled_Wood_Sourcing__c,
      PEFCCOCTrademarkUseStd:!!apiData.PEFC_COC_Trademark_Use_Std__c,
      SFI2022Section4ChainofCustody:!!apiData.SFI_2022_Section_4_Chain_of_Custody__c,
      fscstdChainOfCustody: !!apiData.FSC_STD_Chain_Of_Custody__c,
      fscstD40004:!!apiData.FSC_STD_40_004__c,
      fscstD01004V10:!!apiData.FSC_STD_01_004_V1_0__c,
      fscstdTrademarkUse: !!apiData.FSC_STD_Trademark_Use__c,
      fscProductGroupList: !!apiData.FSC_Product_Group_List__c,
      pglfscAsSeperateRecord: !!apiData.PGL_FSC_as_seperate_record__c,
      fscProductFilename: apiData.FSC_Product_Filename__c || null,
      pefcsfirwProductCategories: !!apiData.PEFC_SFI_RW_Product_Categories__c,
      productListComparisonSCSFSC: apiData.Product_List_Comparison_SCS_FSC__c || null,
      productListComparisonSCSPEFC: apiData.Product_List_Comparison_SCS_PEFC__c || null,
      reclaimedMaterialsInformation: !!apiData.Reclaimed_Materials_Information__c,
      descriptionOfTheOrganizationSverifi: apiData.Description_of_the_organization_s_verifi__c || "",
      multiSiteGroupInformation: !!apiData.Multi_Site_Group_Information__c,
      describeManagementSystem: apiData.Describe_Management_System__c || '',
      describeManagementOfNonConformities: apiData.Describe_Management_of_non_conformities__c || '',
      descriptionGroupMultisiteLevel: apiData.Description_Group_Multisite_Level__c || '',
      describeMaterialSourcing: apiData.Describe_Material_sourcing__c || '',
      siteRelationshipsAdditionRemovalP: apiData.Site_relationships_addition_removal_p__c || '',
      fscaafData: !!apiData.FSC_AAF_Data__c,
      fyStartDate: apiData.FY_Start_Date__c || null,
      fyEndDate: apiData.FY_End_Date__c || null,
      fptTurnoverLocalCurrency: apiData.FPT_Turnover_Local_Currency__c || "",
      fptLocalCurrencyUnit: apiData.FPT_Local_Currency_Unit__c || "",
      totalRevenueUSD: apiData.Total_Revenue_USD__c || "",
      fscDataRecentFY: !!apiData.FSC_Data_Recent_FY__c,
      fptTurnoverUSD: apiData.FPT_Turnover_USD__c || "",
      totalRevenueLocalCurrency: apiData.Total_Revenue_Local_Currency__c || "",
      fpttr: apiData.FPT_TR__c || null,
      auditorCertificationReviewFSC: apiData.Auditor_Certification_Review_FSC__c|| null,
      auditorCertificationReviewPEFC: apiData.Auditor_Certification_Review_PEFC__c || null,
      auditorCertificationReviewSFI: apiData.Auditor_Certification_Review_SFI__c || null,
      auditorCertificationReviewOther: apiData.Auditor_Certification_Review_Other__c || null,
      auditorCommentsFSC: apiData.Auditor_Comments_FSC__c || "",
      auditorCommentsPEFC: apiData.Auditor_Comments_PEFC__c || "",
      auditorCommentsSFI: apiData.Auditor_Comments_SFI__c || "",
      auditorCommentsOther: apiData.Auditor_Comments_Other__c || "",
      scsCertificationDecisionFSC:apiData.SCS_Certification_Decision_FSC__c || null,
      scsCertificationDecisionPEFC: apiData.SCS_Certification_Decision_PEFC__c || null,
      scsCertificationDecisionSFI: apiData.SCS_Certification_Decision_SFI__c || null,
      scsCertificationDecisionOther: apiData.SCS_Certification_Decision_Other__c || null,
      certificationDecisionsBy: apiData.Certification_Decision_s_By__c || null,
      centralOfficeAuditProgram: !!apiData.Central_Office_Audit_Program__c,
      scsDecisionCommentsFSC: apiData.SCS_Decision_Comments_FSC__c || '',
      scsDecisionCommentsPEFC: apiData.SCS_Decision_Comments_PEFC__c || '',
      scsDecisionCommentsSFI: apiData.SCS_Decision_Comments_SFI__c || '',
      scsDecisionCommentsOther: apiData.SCS_Decision_Comments_Other__c || '',
      dateOfReportFinalization: apiData.Date_Of_Report_Finalization__c || null,
      certificateType: apiData.Certificate_Type__c || null,
      annualGrowthRate: apiData.Annual_growth_rate__c || null,
      allowableSizeLimit: apiData.Allowable_Size_Limit__c || null,
      id: apiData.id || null,
      // for stable check disable section 3 and 4.
      // opportunityCertificates: [],
      // certifiedProducts: [],

      opportunityCertificates: apiData.opportunityCertificates,
      certifiedProducts: formatSpiceIds(apiData?.productRows) || [],
    };
  };

  const splitAndFormOutputCategory = (cat: string) => {
    const catArr = cat.split(";");
    const outputCat = catArr.map((item: string) => ({
      id: item,
      label: item,
      value: item,
    }));

    return outputCat;
  }
  

  useEffect(() => {
    let filteredProductRows: any = [];
    if (section34Data?.opportunityCertificates?.length > 0) {
    section34Data.opportunityCertificates.forEach((item: any) => {
      const certifiedProducts = item.Certified_Products__r?.records || [];
      const initialRows = certifiedProducts.map((product: any, rowIndex: number) => {
        const relatedSpeciesStr = product.Related_Species__c || '';

        const speciesLatinName = product.Certified_Species__r?.records.map((item: any) => ({
          id: item.Species__c,
          label: item.Species__r.Name,
          value: item.Species__r.Name,
          certifiedProductId: item.Certified_Product__c,
          certifiedSpeciesId: item.id
        }));

        return {
          certificateId: product.Certificate_Number__c || "",
          productCodeL1: product.Level_1__c || null,
          productCodeL2: product.Level_2__c || null,
          productCodeL3: product.Level_3__c || null,
          speciesCommonName: product.Trade_Name__c || "",
          speciesLatinName: speciesLatinName  || [],// array of species names as object
          primaryActivity: product.Primary_Activity__c || null,
          secondaryActivity: product.Secondary_Activity__c || null,
          certifiedProductId: product.id || null,
          fscOutputClaim: product.Output_Category__c ? splitAndFormOutputCategory(product.Output_Category__c) : [], // assuming multiselect
        };
      });
      filteredProductRows = [...filteredProductRows, ...initialRows]
    }); 
  }
    setFormData({ ...reportformData, productRows: filteredProductRows, opportunityCertificates: sortOpperCertificateIds() || [] });
    setinitialFormData({ ...reportformData, productRows: filteredProductRows, opportunityCertificates: sortOpperCertificateIds() || [] });
  }, [reportformData]);

  const handleSave = async () => {
      //console.error("postformData:", formData);
      setDraftStatus("started");
      let editdata = mapApiDataToFormData(formData);
      console.error("postformData:", editdata);

    try {
      setIsLoading(true);
      let editdata = mapApiDataToFormData(formData);
      const response = await editSummaryReport(reportId, editdata);
      if (response.isSuccess) {
        setShowToaster(true);
        
        setIsLoading(false);
        setDraftStatus("success");
        setTimeout(() => {
        setDraftStatus("notStarted");
          setIsDrawerOpen(false);
        }, 2500)
      } else {
        console.error("API Error:", response.message);
        setIsLoading(false);
      }
    } catch (error) {
      setDraftStatus("notStarted");
      console.error("Submission failed:", error);
      setIsLoading(false);
    }
  };

  const checkFormValuesAremodifiedOrNot = (obj1: any, obj2: any) => {
    if (obj1 === obj2) return true;

  if (
    typeof obj1 !== 'object' || obj1 === null ||
    typeof obj2 !== 'object' || obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Quick check for key length mismatch
  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key)) return false;

    const val1 = obj1[key];
    const val2 = obj2[key];

    const areObjects = typeof val1 === 'object' && typeof val2 === 'object';

    if (
      areObjects && !checkFormValuesAremodifiedOrNot(val1, val2) ||
      !areObjects && val1 !== val2
    ) {
      return false;
    }
  }

  return true;
  }

  useEffect(() => {
    console.log("form data", formData)
    console.log("initialFormData", initialFormData)
    console.log(checkFormValuesAremodifiedOrNot(initialFormData, formData))
    if (!checkFormValuesAremodifiedOrNot(initialFormData, formData)) {
      setDraftStatus("modified");
    } else {
      setDraftStatus("notStarted");
    } 
  }, [initialFormData,formData])

  const toggleAccordion = (key: number) => {
    setOpenAccordion(prev => {
      const updated = new Set(prev);
      updated.has(key) ? updated.delete(key) : updated.add(key);
      return updated;
    });
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
  };

  const isAnnexAHidden = formData.FSC_Product_Group_List__c && formData.PEFC_SFI_RW_Product_Categories__c

  const accordion = [
    {
      key: 1,
      title: "Section 1: Organization Description",
      content: (
        <OrganizationDescription formData={formData} setFormData={setFormData} />
      ),
    },
    {
        key: 2,
        title: "Section 2: Confirmation of Changes",
        content: (
          <ConfirmationOfChanges formData={formData} setFormData={setFormData} />
        ),
      },
      {
        key: 3,
        title: "Section 3: Certificate Scope",
        content: (
          <CertificateScope formData={formData} section34Data={section34Data} setFormData={setFormData} />
        ),
      },
      {
        key: 4,
        title: "Section 4: FSC Product Group List",
        content: (
          <FscProductGroupList formData={formData} section34Data={section34Data} setFormData={setFormData} />
        ),
      },
      {
        key: 5,
        title: "Section 5: PEFC/SFI/RW Product Categories",
        content: (
          <PeFcsfiRwProductCategories setFormData={setFormData} formData={formData} />
        )    
        },
        {
          key: 6,
          title: "Annex A: Product Group List",
          content: <DocumentUpload folderPath={folderPath} />,
          isOpen: true,
          hidden: isAnnexAHidden
        },
        {
          key: 7,
          title: "Section 6: Reclaimed Materials Information",
          content: (
            <ReclaimedMaterialsInfo formData={formData} setFormData={setFormData} />
          ),
          isOpen: true,
        },
        {
          key: 8,
          title: "Section 7: Multi-Site / Group Information",
          content: (
            <MultiSiteGroupInfo formData={formData} setFormData={setFormData} />
          ),
          isOpen: true,
        },
        {
          key: 9,
          title: "Section 8: FSC AAF Data",
          content: <FscAafData formData={formData} setFormData={setFormData} />,
          isOpen: true,
        },

        {
          key: 10,
          title: "Section 9: Summary of Assessment",
          content: (
            <SummaryOfAssessment formData={formData} setFormData={setFormData} />
          ),
          isOpen: true,
        },
    {
      key: 11,
      title: "Communications",
      content: (
        <Messages
          projectId={projectId}
          reportId={reportId}
          recipientUser=""
          sidebyside
          disabled={false}
        />
      ),
    },
  ];

  return (
    <div className="text-center">
      <Drawer isOpen={isDrawerOpen} onClose={handleClose} title={"FSC CoC Summary Report"} subtitle={reportName} >
        {!isLoading ? "" : <Loader/>}
        {accordion.map(section => (
         !section.hidden &&  <CustomAccordion
            key={`accordion-${section.key}`}
            id={`accordion-${section.key}`}
            title={section.title}
            data={section.content}
            isOpen={openAccordion.has(section.key)}
            toggleAccordion={() => toggleAccordion(section.key)}
          />
        ))}

        <FloatButton draftStatus={draftStatus} onSaveDraft={handleSave} />
      </Drawer>

      <Toaster
        type="success"
        show={showToaster}
        setShow={setShowToaster}
        message="Summary Report was saved successfully"
      />
    </div>
  );
};

export default SummaryReport;
